import React from 'react';

import PropTypes from 'prop-types';

import { productTitle } from '@src/components/products';

export const Products = (props) => {
    const { products } = props;

    return (
        <span>
            {
                products.map((product, idx) => {
                    return (
                        <span key={product.id}>
                            { productTitle(product) }
                            { idx < products.length - 1 ? ', ' : '' }
                        </span>
                    );
                })
            }
        </span>
    );
};

Products.propTypes = {
    products: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
    })).isRequired,
};
